import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Admin } from 'src/app/interfaces/admin';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard-login',
  templateUrl: './dashboard-login.component.html',
  styleUrls: ['./dashboard-login.component.scss']
})
export class DashboardLoginComponent implements OnInit {

  constructor(private router: Router) { }

  email:string ='dashboard2020@admin.com'

  password: string = 'dashboard2020admin'

  ngOnInit() {}

  login(f:NgForm) {
    let email = (<Admin>f.value).email,
        password = (<Admin>f.value).password;

        if(email !==this.email || password !==this.password) {

          document.getElementById('done').style.display="block";
          setTimeout(()=>{
            document.getElementById('done').style.display="none";
          }, 3000);

          return false
        }
        else {
          // this.accessDashboard.accessDashboard = true;
           this.router.navigate(['/dashboard-panel'])
        }
  }

}
